import { Space } from 'antd';
import React, { Fragment } from 'react';
import FilePaste from '@/assets/images/header/file-paste.react.svg?react';
import UserGroup from '@/assets/images/header/user-group.react.svg?react';
import { MultiApp } from '@/config/context';
import { isInternal } from '@/infrastructure/auth';
import { getParamFromUrl } from '@/infrastructure/history';
import { AppSlot } from '@/presentation/components/app-slot';
import { IssueRecommend } from '@/presentation/components/issue-recomend';
import { ShareButton } from '@/presentation/layouts-pro/header/share';
import { AvatarMenu } from '@/presentation/layouts/header/avatar';
import { TopMenuButton } from '@/presentation/layouts/header/button';
import { Notice } from '@/presentation/layouts/header/notice';
import { useStores } from '@/presentation/store';
import { BuglyCopilot } from './copilot';
import { Helper } from './helper';

export const TopMenu = () => {
  const { hasProduct } = useStores().ProductStore;
  const productId = getParamFromUrl('productId');

  return (
    <Fragment>
      <Space size={24}>
        <AppSlot apps={[MultiApp.WOA]}>
          {productId && <IssueRecommend />}
        </AppSlot>
        {hasProduct && <Space style={{ marginTop: '15px', minWidth: 259, justifyContent: 'flex-end' }}>
          <TopMenuButton onClick={() => window.open('https://docs.bugly.woa.com', '_blank')}>
            <FilePaste />
            <span>文档中心</span>
          </TopMenuButton>
          {!isInternal() && <TopMenuButton onClick={() => window.open('https://mk.woa.com/coterie/505', '_blank')}>
            <UserGroup />
            <span>论坛</span>
          </TopMenuButton>}
          <Notice />
          <BuglyCopilot />
          <Helper ></Helper>
          <ShareButton />
        </Space>}
        <AvatarMenu />
      </Space>
    </Fragment>
  );
};
